<template>
	<div>
		<div class="h-base-nav-links" v-if="!contactOnly">
			<v-btn class="h-btn-2" round outline color="#2C618E" @click="$router.go(-1)" v-if="!noBack" role="button">&#x276E; Go Back</v-btn>
			<v-btn class="h-btn-2" round outline color="#2C618E" to="/" v-if="home" role="button">Return to Help</v-btn>
		</div>

		<v-btn
				right
				fixed
				dark
				color="#EAEFF2"
				v-if="!noContact"
				@click="show_contacts = true"
				class="contact-btn"
		>
			<div>
				<div class="contact-nav-title">
					<span class="contact-btn-text">Get in touch with us!</span>
				</div>
				<div>
					<v-icon class="icon-phone-btn">phone</v-icon>
					<v-icon class="icon-mail-btn">mail</v-icon>
				</div>
			</div>
		</v-btn>

		<v-dialog
				v-model="show_contacts"
				width="500"
		>
			<v-icon v-if="is_mobile" class="contact-dialog-close" @click="show_contacts = false">close</v-icon>
			<v-card>
				<v-card-title
						class="contact-dialog-title"
						:class="{'headline grey lighten-2': !is_mobile}"
				>
					Need to contact the customer service department?
				</v-card-title>

				<v-card-text>
					<v-form
							ref="form"
							v-model="valid"
							lazy-validation
					>
						<v-layout wrap>
							<v-flex xs12>
								<v-text-field
										name="full_name"
										v-model="name"
										:counter="60"
										label="Name"
										:rules="[rules.required]"
										required
										:box="!is_mobile"
										:outline="is_mobile"
										:hideDetails="is_mobile"
										flat
										class="h-contact-us-input required"
								></v-text-field>
							</v-flex>
							<v-flex xs12>

								<v-text-field
										name="email_from"
										v-model="email"
										type="email"
										:counter="60"
										label="E-mail (as used on your order)"
										:rules="[rules.required, rules.email]"
										required
										:box="!is_mobile"
										:outline="is_mobile"
										:hideDetails="is_mobile"
										flat
										height="20px"
										class="h-contact-us-input required"
								></v-text-field>

							</v-flex>
							<v-flex xs12>

								<v-select
										:items="subjects"
										v-model="subject"
										label="Select Message Subject"
										:rules="[rules.required]"
										required
										:box="!is_mobile"
										:outline="is_mobile"
										:hideDetails="is_mobile"
										flat
										height="10px"
										class="h-contact-us-input required"
								></v-select>

							</v-flex>
							<v-flex xs12>

								<v-text-field
										name="order_id"
										v-model="order_id"
										:counter="8"
										label="Order ID"
										:box="!is_mobile"
										:outline="is_mobile"
										:hideDetails="is_mobile"
										flat
										class="h-contact-us-input"
								></v-text-field>

							</v-flex>
							<v-flex xs12>

								<v-textarea
										name="message"
										v-model="body"
										label="Email Text"
										:rules="[rules.required]"
										required
										:box="!is_mobile"
										:outline="is_mobile"
										:hideDetails="is_mobile"
										flat
										class="h-contact-us-input required"
								></v-textarea>

							</v-flex>

							<v-flex xs12>
								<div class="co-captcha-panel" v-show="!captcha_response">
									<vue-recaptcha
										ref="recaptcha"
										@verify="onCaptchaVerify"
										:sitekey="$globs['captcha_settings']['public_key']"
										size="normal"
									>
									</vue-recaptcha>
								</div>
							</v-flex>

							<v-flex xs12>
								<v-alert
									v-show="rest_error"
									type="error"
								>{{ rest_error_msg }}</v-alert>
							</v-flex>

							<v-flex xs12>
								<input type="hidden" name="subject" :value="subject">
								<input type="hidden" name="captcha_response" :value="captcha_response">

								<v-btn  class="h-cs-submit-button"
										color="#7DADED" large round
								       :disabled="rest_request"
								       @click="sendCSMessage">Send</v-btn>
								<v-btn v-if="!is_mobile"
									   @click="show_contacts = false">Cancel</v-btn>
							</v-flex>
						</v-layout>

					</v-form>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-title
						:class="[!is_mobile ?  'grey lighten-2' : '']"
						class="headline h-cs-phone-title"
						primary-title
				>
					{{ toll_free_phone_title_override }}
				</v-card-title>

				<v-card-text class="h-cs-phone-block">
					{{ toll_free_phone_text_override }}
					<h1 class="h-cs-phone-number">{{ customer_service_phone }}</h1>
				</v-card-text>


			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import Axios from 'axios';
	import VueRecaptcha from 'vue-recaptcha';

	export default {
		name: "BaseNavLinks",

		components: {
			VueRecaptcha
		},

		props: {
			home: {
				type: Boolean,
				default: false
			},
			noBack: {
				type: Boolean,
				default: false
			},
			noContact: {
				type: Boolean,
				default: true
			},
			contactOnly: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				show_contacts: false,

				name: '',
				email: '',
				order_id: '',
				body: '',
				valid: true,
				subject: null,

				rules: {
					required: value => !!value || 'Required.',
					email: value => {
						const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						return pattern.test(value) || 'Invalid e-mail.'
					}
				},

				subjects: [
					'Track Items',
					'Return Process',
					'Cancel',
					'Did Not Receive',
					'eBook - Did Not Receive',
					"Item Didn't Ship",
					'Contact Seller',
					'Book Information',
					'Other',
				],

				captcha_response: null,

				rest_request: false,
				rest_error: false,
				rest_error_code: null,
				rest_error_msg: '',
			};
		},

		computed: {
			customer_service_phone() {
				return this.$globs.institute_info.phone || '855-955-0398';
			},
			toll_free_phone_title_override() {
				return this.$globs.institute_info.toll_free_phone_title_override || 'Toll-Free Phone';
			},
			toll_free_phone_text_override() {
				let timezone_text = this.$globs.institute_info.timezone || '';
				let toll_free_phone_text = 'We have customer service agents available to help from 9am to 5pm '
					+ timezone_text
					+ ', Monday through Friday, with 24/7 coverage during the back-to-school season.';

				return this.$globs.institute_info.toll_free_phone_text_override || toll_free_phone_text;
			}
		},

		methods: {
			sendCSMessage() {
				if (!this.$refs.form.validate()) return;
				this.rest_request = true;

				this.rest_error = false;
				this.rest_error_code = null;
				this.rest_error_msg = '';

				let self = this;
				Axios.post('/service/customer_help/rest/index.php/customer_help/send_contact_us_message_to_cs', {
					captcha_response: this.captcha_response,
					subject: this.subject,
					message: this.body,
					order_id: this.order_id,
					email_from: this.email,
					full_name: this.name
				}).then(({data}) => {
					self.show_contacts = false;
					document.location.href = '/help?#/cs_request_submitted';

				}).catch((error) => {
					if (error.response && error.response['data'] && error.response['data']['error']) {
						if (error.response['data']['error']['code'] !== 200) {
							let error_code = error.response['data']['error']['code'];
							let error_msg = error.response['data']['error']['data']['message'];

							self.rest_error = true;
							self.rest_error_code = error_code;
							self.rest_error_msg = error_msg;
						}
					}

				}).finally(() => {
					self.resetCaptchas();
					self.rest_request = false;
				});

			},

			onCaptchaVerify(response) {
				this.captcha_response = response;
			},

			resetCaptchas() {
				this.captcha_response = null;

				if (this.$refs['recaptcha']) {
					this.$refs['recaptcha'].reset();
				}
			},
		},
	}
</script>

<style scoped lang="less">
	@media  screen and (min-width : 767px) {
	  .contact-nav-title {
		margin-bottom: 5px;
	  }
	  .icon-phone-btn,
	  .icon-mail-btn {
		padding-top: 7px;
		width: 60px;
		height: 37px;
		background: #2C618E;
		border-radius: 3px;
	  }
	  .contact-btn {
		width: 80px!important;
		height: 97px!important;
		border: 1px solid #BDCEDA;
		border-radius: 3px;
		&.v-btn {
		  min-width: 170px!important;
		}

		.contact-btn-text {
		  width: 80px;
		  height: 11px;
		  font-style: normal;
		  font-weight: 600;
		  padding-bottom: 10px;
		  font-size: 10px;
		  line-height: 11px;
		  color: #2C618E;
		}
	  }
	}

	.h-base-nav-links {
		margin-top: 40px;
	}

	.h-cs-phone-number {
		color: #000;
		margin: 20px 0;
		font-size: 16pt;
	}
	.contact-btn {
	  z-index: 1;
	  padding: 0;
	  width: 80px;
	  height: 50px;
	  top: 50%;
	  &.v-btn {
		min-width: 40px;
	  }

	  .contact-btn-text {
		font-size: 8pt;
	  }
	}

	.co-captcha-panel {
		margin: 10px 0;
		border-top: 1px solid #E0E0E0;
		padding: 20px 0 0 0;
		@media screen and (max-width: 600px) {
			padding: 10px 0 0;
			display: flex;
			justify-content: center;
			max-width: 100vw;
		}
	}

	@media  screen and (min-width : 320px) and (max-width : 480px) {
		.h-cs-phone-title {
			padding: 0;
			margin: 1em 0 0 0;
			text-align: center;
			display: block;
			font-weight: bold;
		}
	  .contact-btn {
		background-color:#316d9b!important;
	  }
		.h-cs-phone-block {
			text-align: center;
			padding: 0 16px 16px 16px;
			.h-cs-phone-number {
				font-weight: bold;
			}
		}
	}
</style>
